import { Grid, LinearProgress } from '@material-ui/core'
import { TFunction } from 'i18next'
import { FC } from 'react'
import { Field, reduxForm } from 'redux-form'
import { CloseDialog, UpdateStatusWithForm } from '../../../actions/types'

import { SubmitFormButton, DialogButtons } from '../../../components/Buttons'
import ErrorMessage from '../../../components/Error/ErrorMessage'
import { ReduxTextField } from '../../../components/FormInput/ReduxWrappers'
import { ReduxForm } from '../../../types/forms'
import { required } from '../../../utils/validation/forms'

interface UpdateStatusFormProps extends ReduxForm {
  t: TFunction
  submitting: boolean
  closeDialog: CloseDialog
  updateStatusWithForm: UpdateStatusWithForm
}

export interface UpdateStatusWithFormFormData {
  contractWantedId: string
  status: string
  isFromApplicationCard: boolean
}

const UpdateStatusForm: FC<UpdateStatusFormProps> = ({
  handleSubmit,
  error,
  t,
  updateStatusWithForm,
  closeDialog,
  submitting
}) => (
  <form onSubmit={handleSubmit(updateStatusWithForm)}>
    <Grid container>
      <Grid item xs={12}>
        <Field
          fullWidth
          validate={[required]}
          name='contractWantedId'
          label={t('application.list.applicationId')}
          component={ReduxTextField}
          required
        />
      </Grid>
      <Grid item xs={12}>
        <DialogButtons
          closeDialog={closeDialog}
          dialogName='Confirm'
          ButtonTwo={
            <SubmitFormButton
              textColor='white'
              variant='contained'
              submitting={submitting}
            />
          }
        />
      </Grid>
      <ErrorMessage error={error} />
      {submitting && <LinearProgress />}
    </Grid>
  </form>
)

export default reduxForm({
  form: 'UpdateStatusForm'
})(UpdateStatusForm as any) as any
